export const SET_ONLINE_STATUS = 'SET_ONLINE_STATUS';
export const SET_RESTAURANT_DATA = 'SET_RESTAURANT_DATA';
export const SET_WAIT_TIME = 'SET_WAIT_TIME';